import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import ArrowLeftLineIcon from 'remixicon-react/ArrowLeftLineIcon';
import { useForm, Controller } from "react-hook-form";
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import CardLayout from '../../components/utils/CardLayout'
import Button from '../../components/utils/Button'
import Table from '../../components/utils/Table';
import Papa from 'papaparse'
import Alert from '../../components/utils/Alert';
import CheckLineIcon from 'remixicon-react/CheckLineIcon';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import activationRequestActions from '../../redux/activationRequest/actions';
import networkActions from '../../redux/network/actions';
import { isKeyUnique, validateIMEI, validateSNo, validatePin, selectCharacters, validateEmail, validateZipCode, validateMSISDN } from '../../helpers/commonFunction';


const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;
const ACTIVATION_LIMIT = 100;
const { validateSerialNumber, checkImeiNumber, createManualActivation, resetValidateMessage, validateImeiNumber } = activationRequestActions;
const { getActiveNetworkDAilyPlanMapping } = networkActions;

const ManualActivationForm = ({ back, searchData }) => {
    const dispatch = useDispatch();
    const [simType, setSimType] = useState(0);
    const { shortCodeSimType } = useSelector((state) => state.shortCode);
    const { networkResultData } = useSelector((state) => state.network);
    const { validateSerialNumberLoading, checkImeiNumberLoading, checkImeiNumberData, validateSerialNumberData, createManualActivationLoading, createManualActivationError, createManualActivationMessage } = useSelector((state) => state.activationRequest);
    const [previewData, setPreviewData] = useState([]);
    const [csvLimitError, setCsvLimitError] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [showPreviewType, setShowPreviewType] = useState(2);
    const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
    const [previewSuccessData, setPreviewSuccessData] = useState([]);
    const [previewFailedData, setPreviewFailedData] = useState([]);
    const [csvError, setCsvError] = useState(false);
    const [activationRequests, setActivationRequests] = useState([]);
    const [apiCall, setApiCall] = useState(false);
    // const [networkId, setNetworkId] = useState(null);

    const {
        register: manualActivationRegister,
        handleSubmit: manualctivationHandleSubmit,
        formState: { errors: manualActivationError },
        watch: manualActivationWatch,
        reset: manualActivationReset,
        setValue: manualActivationSetValue,
        setError: manualActivationSetError,
        clearErrors: manualActivationClearErrors,
        control: manualActivationcontrol, } = useForm({
            defaultValues: {
            }
        });
    const simTypeWached = manualActivationWatch('simType');
    const networkId = manualActivationWatch('networkID')


    const previewColumns = simType == 25 ? [
        { displayName: 'IMEI', key: 'IMEI' },
        { displayName: 'SERIAL NUMBER', key: 'SerialNumber' },
        { displayName: 'CUSTOMER EMAIL', key: 'CustomerEmail' },
        { displayName: 'MSISDN', key: 'Msisdn' },
        { displayName: 'ZIP CODE', key: 'ZipCode' },
        { displayName: 'PIN', key: 'Pin' },
        { displayName: 'MEXICO & CANADA CALLING', key: 'MexicoCanadaCalling' },
        { displayName: 'REASON', key: 'Reason' },
        { displayName: 'VALID', key: 'Valid' },
    ] : [
        { displayName: 'IMEI', key: 'IMEI' },
        { displayName: 'SERIAL NUMBER/EID', key: 'SerialNumber' },
        { displayName: 'CUSTOMER EMAIL', key: 'CustomerEmail' },
        { displayName: 'MSISDN', key: 'Msisdn' },
        { displayName: 'ZIP CODE', key: 'ZipCode' },
        { displayName: 'PIN', key: 'Pin' },
        { displayName: 'MEXICO & CANADA CALLING', key: 'MexicoCanadaCalling' },
        { displayName: 'REASON', key: 'Reason' },
        { displayName: 'VALID', key: 'Valid' },
    ];

    useEffect(() => {
        if (networkResultData.length === 1) {
            manualActivationSetValue('networkID', networkResultData[0].ID);
        }
    }, [networkResultData, manualActivationSetValue]);

    useEffect(() => {
        dispatch(getActiveNetworkDAilyPlanMapping());
    }, [])

    useEffect(() => {
        if (simTypeWached) {
            setSimType(simTypeWached);
        }
    }, [simTypeWached]);

    useEffect(() => {
        if (csvLimitError !== null && csvLimitError !== undefined) {
            displayAlert(csvLimitError, 'alert-danger');
        }
        if (createManualActivationError !== null && createManualActivationError !== undefined) {
            displayAlert(createManualActivationError, 'alert-danger');
        }
    }, [csvLimitError, createManualActivationError]);

    useEffect(() => {
        if (createManualActivationMessage) {
            back();
            dispatch(resetValidateMessage());
        }
    }, [createManualActivationMessage]);

    useEffect(() => {
        if (validateSerialNumberData.length > 0) {
            setApiCall(false);
            let newDataSource = previewData.map((item) => {
                let count = validateSerialNumberData.filter((item1) => item1.SerialNumber == item.SerialNumber);
                if (count.length > 0) {
                    if (count[0].Status === 0) {
                        item.Valid = <CloseLineIcon color='#e74c3c' />
                        item.Status = 0;
                    }
                    item.Reason = count[0].ExistStatus;
                }
                return item;
            });
            setPreviewData(newDataSource);

            let successCount = validateSerialNumberData.filter((item) => item.Status === 1);
            setPreviewSuccessCount(successCount.length);
            // For API Request
            let newDataRequest = activationRequests.map((item) => {
                let count = validateSerialNumberData.filter((item1) => item1.SerialNumber == item.simNumber);
                if (count.length > 0) {
                    if (count[0].Status === 0) {
                        item.status = 0;
                        item.reason = count[0].ExistStatus;
                    }
                }
                return item;
            });
            setActivationRequests(newDataRequest);
        }
    }, [validateSerialNumberData]);

    useEffect(() => {
        if (checkImeiNumberData.length > 0) {
            setApiCall(false);
            let newDataSource = previewData.map((item) => {
                let count = checkImeiNumberData.filter((item1) => item1.IMEI == item.IMEI);
                if (count.length > 0) {
                    if (count[0].Status === 0) {
                        item.Valid = <CloseLineIcon color='#e74c3c' />
                        item.Status = 0;
                    }
                    item.Reason = count[0].ExistStatus;
                }
                return item;
            });
            setPreviewData(newDataSource);

            let successCount = checkImeiNumberData.filter((item) => item.Status === 1);
            setPreviewSuccessCount(successCount.length);
            // For API Request
            let newDataRequest = activationRequests.map((item) => {
                let count = checkImeiNumberData.filter((item1) => item1.IMEI == item.IMEI);
                if (count.length > 0) {
                    if (count[0].Status === 0) {
                        item.status = 0;
                        item.reason = count[0].ExistStatus;
                    }
                }
                return item;
            });
            setActivationRequests(newDataRequest);
        }
    }, [checkImeiNumberData]);

    useEffect(() => {
        if (apiCall && previewData.length > 0) {
            let validData = previewData.filter((item) => item.Status == 1);
            if (validData.length > 0) {
                if (simType == 25) {
                    let serial_number_array = validData.map((item) => item.SerialNumber);
                    dispatch(validateSerialNumber(serial_number_array));
                } else if (simType == 26) {
                    let imei_number_array = validData.map((item) => item.IMEI);
                    dispatch(checkImeiNumber(imei_number_array));
                }

            }
        }
    }, [previewData]);

    useEffect(() => {
        if (previewData.length > 0) {
            let successPreview = previewData.filter((item) => item.Status == 1);
            let failedPreview = previewData.filter((item) => item.Status == 0);
            setPreviewSuccessData(successPreview);
            setPreviewFailedData(failedPreview);
        }
    }, [previewData]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
    }

    const downloadSampleFile = () => {
        if (simType != '') {
            if (simType == 25) {
                let url = `${BASE_URL}/assets/csv/manual-activation-sample-file.csv`;
                let link = document.createElement('a');
                link.href = url;
                link.download = 'p-sim-manual-activation-sample-file.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else if (simType == 26) {
                let url = `${BASE_URL}/assets/csv/manual-activation-sample-file.csv`;
                let link = document.createElement('a');
                link.href = url;
                link.download = 'e-sim-manual-activation-sample-file.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            manualActivationSetError("simType", { type: "custom", message: "Sim type is required !" })
        }
    }

    const handleNetwork = (e) => {
        setPreviewData([]);
        manualActivationSetValue("uploadedFile", "")
        manualActivationSetValue("simType", "")
    }

    const handleFileChange = (e) => {
        manualActivationClearErrors(['uploadedFile']);
        setPreviewData([]);
        setActivationRequests([]);
        const fileReader = new FileReader();
        let file = e.target.files[0];

        if (!file) {
            manualActivationSetError("uploadedFile", { type: "custom", message: "Csv is required!" })
            setCsvError(true);
            return;
        } else {
            let fileNameArr = file.name.split('.');
            let fileExt = fileNameArr[fileNameArr.length - 1];

            if (!["csv"].includes(fileExt.toLowerCase())) {
                manualActivationSetError("uploadedFile", { type: "custom", message: "Invalid file type. Only CSV file allowed." })
                setCsvError(true);
                return;
            }
        }

        if (file) {
            fileReader.onload = async ({ target }) => {
                const csvOutput = Papa.parse(target.result, { header: true, skipEmptyLines: true });
                const parsedRawData = csvOutput?.data;
                const parsedData = parsedRawData.filter(row => {
                    return Object.values(row).some(value => value?.toString().trim() !== "");
                });
                if (!parsedData || parsedData.length === 0) {
                    manualActivationSetError("uploadedFile", { type: "custom", message: "CSV file is empty!" });
                    setCsvError(true);
                    return;
                }
                const columns = Object.keys(parsedData[0]);

                if (parsedData.length > 100) {
                    setCsvLimitError('Maximum 100 rows are allowed');
                    setCsvError(true);
                    return;
                } else {
                    setCsvError(true);
                }

                const specifiedColumn = ['IMEI', 'SerialNumber'];
                const isValidCsvHeading = specifiedColumn.every((item) => columns.includes(item));


                if (isValidCsvHeading) {
                    setCsvError(false);
                    let dataSource = parsedData.map((item) => {
                        let error = false;
                        let reason = "";

                        let serialNumber = item.SerialNumber;

                        if (simType === 25) {
                            serialNumber = selectCharacters(serialNumber, networkId);
                            if (!validateSNo(serialNumber, networkId, simType)) {
                                reason = "Invalid Serial Number";
                                setCsvError(true);
                                error = true;
                            }
                        } else {
                            if (serialNumber && serialNumber.length > 32) {
                                serialNumber = serialNumber.substring(0, 32);
                            }
                        }

                        if (!validateIMEI(item.IMEI.slice(0, 15))) {
                            reason = "Invalid IMEI";
                            setCsvError(true);
                            error = true;
                            // } else if (simType === 25 && !validateSNo(selectCharacters(selectedSerial, networkId), networkId, simType)) {
                            //     reason = "Invalid Serial Number";
                            //     setCsvError(true);
                            //     error = true;
                        } else if (!validateEmail(item.CustomerEmail)) {
                            reason = "Invalid email id";
                            setCsvError(true);
                            error = true;
                        }
                        else if (!validateMSISDN(item.MSISDN)) {
                            reason = "Invalid msisdn";
                            setCsvError(true);
                            error = true;
                        } else if (!validateZipCode(item.ZipCode)) {
                            reason = "Invalid zip code";
                            setCsvError(true);
                            error = true;
                        } else if (!validatePin(item.Pin, networkId)) {
                            reason = "Invalid pin";
                            setCsvError(true);
                            error = true;
                        }
                        return {
                            IMEI: item.IMEI.slice(0, 15),
                            SerialNumber: serialNumber,
                            CustomerEmail: item.CustomerEmail,
                            Msisdn: item.MSISDN,
                            ZipCode: item.ZipCode,
                            Pin: item.Pin,
                            MexicoCanadaCalling: item.MexicoCanadaCalling ? item.MexicoCanadaCalling.toUpperCase() : "",
                            Reason: reason,
                            Valid: error ? <CloseLineIcon color='#e74c3c' /> : <CheckLineIcon color='#2ecc71' />,
                            Status: error ? 0 : 1
                        }
                    });

                    if (simType == 25 && !isKeyUnique(dataSource, 'SerialNumber')) {
                        manualActivationSetError("uploadedFile", { type: "custom", message: "Csv contain duplicate SIM number" })
                        return false;
                    }

                    setPreviewData(dataSource);
                    setApiCall(true);

                    let requestData = parsedData.map((item) => {
                        let error = false;
                        let reason = "";
                        let serialNumber = item.SerialNumber;

                        if (simType === 25) {
                            serialNumber = selectCharacters(serialNumber, networkId);
                            if (!validateSNo(serialNumber, networkId, simType)) {
                                reason = "Invalid Serial Number";
                                setCsvError(true);
                                error = true;
                            }
                        } else {
                            if (serialNumber && serialNumber.length > 32) {
                                serialNumber = serialNumber.substring(0, 32);
                            }
                        }

                        if (!validateIMEI(item.IMEI.slice(0, 15))) {
                            reason = "Invalid IMEI";
                            setCsvError(true);
                            error = true;
                            // } else if (!validateSNo(selectCharacters(item.SerialNumber, networkId), networkId, simType)) {
                            //     reason = simType == 25 ? "Invalid Serial Number" : "Serial Number not allowed for e-sim";
                            //     setCsvError(true);
                            //     error = true;
                        } else if (!validateEmail(item.CustomerEmail)) {
                            reason = "Invalid email id";
                            setCsvError(true);
                            error = true;
                        } else if (!validateMSISDN(item.MSISDN)) {
                            reason = "Invalid msisdn";
                            setCsvError(true);
                            error = true;
                        }
                        else if (!validateZipCode(item.ZipCode)) {
                            reason = "Invalid zip code";
                            setCsvError(true);
                            error = true;
                        } else if (!validatePin(item.Pin, networkId)) {
                            reason = "Invalid pin";
                            setCsvError(true);
                            error = true;
                        }

                        return {
                            imeiNumber: item.IMEI.slice(0, 15),
                            // simNumber: selectCharacters(item.SerialNumber, networkId),
                            simNumber: serialNumber,
                            CustomerEmail: item.CustomerEmail,
                            Msisdn: item.MSISDN,
                            ZipCode: item.ZipCode,
                            Pin: item.Pin,
                            MexicoCanadaCalling: item.MexicoCanadaCalling ? item.MexicoCanadaCalling.toUpperCase() : "",
                            status: error ? 0 : 1,
                            reason
                        }

                    });
                    setActivationRequests(requestData);
                } else {
                    manualActivationSetError("uploadedFile", { type: "custom", message: "Invalid Csv Selected" })
                    setCsvError(true);
                }
            };
            fileReader.readAsText(file);
        }
    }

    const handlePreviewTableData = (id) => {
        setShowPreviewType(id)
    }

    const handleAddManualActivation = (data) => {
        let failedRows = activationRequests.filter((item) => item.status == 0);
        if (failedRows.length > 0) {
            alert("Invalid data entered. Please review the information and try again");
            return false;
        }

        data.activationRequests = activationRequests;
        delete data.uploadedFile;
        dispatch(createManualActivation(data, searchData));
    }

    return (
        <CardLayout title="Add Manual Activation">
            <div className="row mb-3">
                <div className='col-lg-12 text-right'>
                    <button type="button" onClick={() => downloadSampleFile()} style={{ background: '#2ecc71', color: '#fff', pointerEvents: 'auto' }} className={`btn font-weight-bold mr-2`}><DownloadCloud2sLineIcon size={16} />Sample File</button>
                    <button type="button" onClick={() => back()} className={`btn btn-danger font-weight-bold`}><ArrowLeftLineIcon size={16} />Back</button>
                </div>
            </div>

            <div className='container'>
                <form onSubmit={manualctivationHandleSubmit(handleAddManualActivation)}>

                    <div className="form-row">

                        <div className="col-md-3 mb-3">
                            <label className='ml-2'> Network <span className='text-danger'>*</span></label>
                            <select className="form-control" placeholder="Select Network" name="networkID"  {...manualActivationRegister("networkID", {
                                required: 'Network is Required',
                            })} onChange={(e) => { handleNetwork(e) }} >
                                <option value="" key="0" >Select</option>
                                {networkResultData.length > 0 && networkResultData.map(network => (
                                    <option name="networkID" value={network.ID} key={network.ID}>{network.NetworkName}</option>
                                ))}
                            </select>
                            {manualActivationError && manualActivationError.networkID && (<div className="invalid-feedback">{manualActivationError.networkID.message}</div>)}
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="ml-2">SIM Type <span className='text-danger'> *</span></label>
                            <select className="form-control" name="simType"
                                {...manualActivationRegister("simType", {
                                    required: 'SIM type is required !',
                                })}
                                onChange={(e) => {
                                    setPreviewData([]);
                                    manualActivationSetValue("uploadedFile", "")
                                    setSimType(parseInt(e.target.value));
                                }}>
                                <option value="">Select</option>
                                {
                                    shortCodeSimType && shortCodeSimType.length > 0 && shortCodeSimType.map((item) => {
                                        return (<option value={item.ID} key={`simType${item.ID}`}> {item.Value} </option>);
                                    })
                                }
                            </select>
                            {manualActivationError && manualActivationError.simType && (<div className="invalid-feedback">{manualActivationError.simType.message}</div>)}
                        </div>


                        <div className="col-md-6 mb-3">
                            <div className="input-group">
                                <label htmlFor="csvFile"><span className='text-danger'>*</span>Upload File </label>
                                <input
                                    type="file"
                                    className="form-control-file"
                                    name='uploadedFile'
                                    id="csvFile"
                                    accept='.csv'
                                    {...manualActivationRegister('uploadedFile', { required: 'Csv is required' })}
                                    onChange={(e) => handleFileChange(e)}
                                />
                                <small className='text-danger'>{`Note : Only ${ACTIVATION_LIMIT} Rows are allowed`}</small>
                                {manualActivationError && manualActivationError.uploadedFile && (<div className="invalid-feedback">{manualActivationError.uploadedFile.message}</div>)}

                            </div>
                        </div>

                    </div>
                    {
                        previewData.length > 0 &&
                        <>
                            <hr />
                            <div className='row p-0 m-0' style={{ cursor: 'pointer' }}>
                                <div className="col-md-4 d-flex justify-content-around align-items-center py-3 preview-box" onClick={() => { handlePreviewTableData(2) }}>
                                    <h4>Total Submitted : {previewData.length}</h4>
                                </div>
                                <div className="col-md-4 d-flex justify-content-around align-items-center preview-box" onClick={() => { handlePreviewTableData(1) }}>
                                    <h4 className='text-success'>Valid : {previewSuccessCount}</h4>
                                </div>
                                <div className="col-md-4 d-flex justify-content-around align-items-center preview-box" onClick={() => { handlePreviewTableData(0) }}>
                                    <h4 className='text-danger'>Invalid : {previewData.length - previewSuccessCount}</h4>
                                </div>
                            </div>
                            {/* loading={validateSerialNumberLoading} */}
                            <div className="col-md-12 mb-3 p-0">
                                <Table columns={previewColumns} loading={simType === 25 ? validateSerialNumberLoading : checkImeiNumberLoading}
                                    data={showPreviewType == 1 ? previewSuccessData : showPreviewType == 0 ? previewFailedData : previewData} pagination={false} />
                            </div>
                        </>
                    }
                    <hr />

                    {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}

                    <div className='text-right row'>
                        <div className="col-md-12">
                            <button type="button" className="btn btn-secondary mr-2" onClick={() => back()}>Close</button>
                            {(activationRequests.filter((item) => item.status === 1).length > 0 && validateSerialNumberLoading === false) ? <Button title="Submit" style="minWidth:80px" loading={createManualActivationLoading} buttonClass="btn btn-primary" buttonType='submit' /> : ''}
                        </div>
                    </div>

                </form>
            </div>

        </CardLayout>
    )
}

export default ManualActivationForm
